import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setRoleType } from "../../../redux/slices/userType";
import { ROLE } from "../../../utils/Constants";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


function RoleSelection({ type = 'login', onClose }) {

  const { t } = useTranslation();
  // Define the available roles
  const roles = [
    { id: "user", name: t("header.role_user"), icon: "👤" }, // Use an emoji or replace with an image component
    { id: "advertiser", name: t("header.role_advertiser"), icon: "🏪" }, // Use an emoji or replace with an image component
  ];


  // State to track the currently selected role
  const [selectedRole, setSelectedRole] = useState("user"); // Default to 'User' as shown in the image

  // Handler for when a role card is clicked
  const handleRoleSelect = (roleId) => {
    setSelectedRole(roleId);
  };

  const dispatch = useDispatch();
  const Navigate = useNavigate();

  // Handler for the Next button
  const handleNext = () => {

    dispatch(setRoleType(selectedRole));
    if (selectedRole === ROLE.USER) {
      type === 'login' ? Navigate('/user/login') : Navigate('/user/signup');
    }
    else {
      type === 'login' ? Navigate('/user/login') : Navigate('/user/signup');
    }
    if (onClose) onClose();

  };



  return (
    <div className="flex flex-col items-center justify-center bg-white">
      <h1 className="headings-h1 text-zinc-950 mb-10">Select the Role</h1>

      {/* Role Selection Grid */}
      <div className="flex flex-1 flex-wrap justify-center gap-6 mb-10 max-w-lg w-full">
        {roles.map((role) => (
          <div
            key={role.id}
            className={`
              flex flex-col items-center justify-center p-4 min-w-[240px] w-full sm:w-48 h-48 rounded-[16px]
              cursor-pointer transition-all duration-300 ease-in-out
              ${selectedRole === role.id
                ? "border-1 border-red-400 bg-white" // Selected state (Red border)
                : "border border-zinc-100 bg-white hover:border-red-200" // Unselected state
              }
            `}
            onClick={() => handleRoleSelect(role.id)}
          >
            {/* Icon/Image Section - Using placehold.co images to mimic the look */}
            {role.id === "user" ? (
              // User Icon - Placeholder for the blue figure
              <img
                src="/images/user.svg" // Placeholder color for the icon
                alt="User Icon"
                className=""
              />
            ) : (
              // Advertiser Icon - Placeholder for the storefront
              <img
                src="/images/advertiser.svg" // Placeholder color for the icon
                alt="Advertiser Icon"
              />
            )}

            {/* Text Label */}
            <span className="headings-h3 mt-4">{role.name}</span>
          </div>
        ))}
      </div>

      {/* Next Button */}
      <button onClick={handleNext} className="btn btn-pri min-w-[205px]">
        Next
      </button>
    </div>
  );
}

export default RoleSelection;
